/**
 * Class handling logs
 */

class AppConsoleService {

  log(level, module, message) {
    switch (level) {
      case 'ERROR':
        console.error(level+ ' | '+ module+ ' | '+ message)
        break
      default :
        console.log(level+ ' | '+ module+ ' | '+ message)
        break
    }

  }

  info(module, message) {
    this.log('INFO', module, message)
  }

  warn(module, message) {
    this.log('WARN', module, message)
  }

  debug(module, message) {
    this.log('DEBUG', module, message)
  }

  error(module, error) {
    let message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
    this.log('ERROR', module, message)
  }


}

export default new AppConsoleService();
